import {
  VALIDATION_INVALID_FORMAT,
  VALIDATION_CI_NUMBER_INPUT,
  VALIDATION_INVALID_BLACKLIST,
} from 'config/variables';

export const regexSequentialPhone = /000000|111111|222222|333333|444444|555555|666666|777777|888888|999999|123456|234567|345678|456789|987654|876543|765432|654321/;
export const regexNumbersWithoutFirstCero = /^[1-9][0-9]*$/;
export const regexNumbersWithoutFirstCeroAndWithA = /^[aA1-9][0-9]*$/;
export const regexNumbersWithoutFirstCeroAndAlphanumeric = /^[a-zA-ZñÑ1-9][a-zA-ZñÑ0-9]*$/;

export type RegexExpWithMsg = {
  regex: RegExp;
  errorMessage: string;
};

// regex
export const REGEX_AREACODE = {
  regex: /^[1-9]\d*$/,
  options: {
    message: VALIDATION_INVALID_FORMAT,
    excludeEmptyString: true,
  },
};

// This particular validation is no longer applicable to PY phone number format (further details: PRSF-4761)
export const REGEX_PHONENUMBER = {
  regex: /^(?!15)\d+$/,
  options: {
    message: 'Formato de teléfono no válido',
    excludeEmptyString: true,
  },
};

export const REGEX_SINGLE_SPACES_BEETWEN_WORDS = {
  regex: /^\S+(?: \S+)*$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_ALPHANUMERIC: RegexExpWithMsg = {
  regex: /^[a-zA-ZñÑ0-9]*$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_ALPHANUMERIC_WITH_SPECIAL_CHARACTERS_FOR_EMAIL: RegexExpWithMsg = {
  regex: /^[A-Za-z0-9.]+$/,
  errorMessage: VALIDATION_INVALID_BLACKLIST,
};

export const RGX_EMAIL_USERNAME: RegexExpWithMsg = {
  regex: /^[0-9a-zñáéíóúäëïöü'+.&,_-]+\.?$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_EMAIL_DOMAIN: RegexExpWithMsg = {
  regex: /^@[^\s.@]+(\.[^\s.@]+)+$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_ALPHANUMERIC_WITH_SPACING: RegexExpWithMsg = {
  regex: /^[a-zA-ZñÑ0-9 ]*$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_LIMITED_AB_ALPHANUMERIC: RegexExpWithMsg = {
  regex: /^[a-bA-B0-9]*$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_EMPTY_STRING = {
  regex: /^$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_NO_SPECIAL_CHARACTERS: RegexExpWithMsg = {
  regex: /^[^\d!¡@#$`°%^&~*(),;.¬¿?´":{}/[\]|<>+_"¨\\=-]*$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_ONLY_NUMBERS: RegexExpWithMsg = {
  regex: /^[0-9]*$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_ONLY_TEXT: RegexExpWithMsg = {
  regex: /^[a-zA-Z\b]+$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_WITH_A_AND_NUMERICAL_WITHOUT_SPACE: RegexExpWithMsg = {
  regex: /^[aA0-9]\d*$/,
  errorMessage: VALIDATION_INVALID_FORMAT,
};

export const RGX_WITHOUT_STARTING_0_AND_AB_EITHER_STARTING_OR_ENDING: RegexExpWithMsg = {
  regex: /^(?!0)([aAbB]\d*|\d*[aAbB])$|^(?!0)[0-9]*$/,
  errorMessage: VALIDATION_CI_NUMBER_INPUT,
};
